import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import GL_logo from '../../assets/Logo/GL Funnel Logo.svg';
import uploadIconActive from '../../assets/Icons/UploadIconActive.svg';
import uploadIcon from '../../assets/Icons/uploadIcon.svg';
import settingIcon from '../../assets/Icons/Setting Icon.svg';
import settingIconActive from '../../assets/Icons/SettingIconActive.svg';

import { clientCompanyName, productName } from '../config/clientsConfig';
import { getIcons, getLogos } from '../Constant/Constant';

const AppBar = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(true);
  const [isSetupMenuOpen, setIsSetupMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const setupMenuRef = useRef(null);
  const navigate = useNavigate();

  const logos = getLogos()


  const userData = JSON.parse(localStorage.getItem('userData'));
  const userName = userData?.user?.name || 'User';
  const userRole = userData?.user?.role || 'Role';

  const handleSignout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const toggleSetupMenu = () => {
    setIsSetupMenuOpen(!isSetupMenuOpen);
    setIsUploadOpen(false);
  };



  const handleClickOutside = (event) => {
    if (setupMenuRef.current && !setupMenuRef.current.contains(event.target)) {
      setIsSetupMenuOpen(false);
      setIsUploadOpen(true);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="w-full h-16 md:h-18 lg:h-20 fixed z-20 top-0 flex items-center justify-between px-6 shadow-md bg-white">
    {/* Logo */}
      <div
        className="flex items-center cursor-pointer"
       
      >
        <img
          className="w-8 h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 2xl:w-12 2xl:h-12"
          src={logos.glFunnelLogo}
          alt="Company Logo"
        />
        <span className="ml-2 text-xl md:text-2xl lg:text-2xl 2xl:text-3xl font-semibold text-customGreen">
          {productName}
        </span>
      </div>

      {/* Upload Icon */}
      {/* <div className="flex gap-12 justify-center md:ml-5 lg:ml-0">
        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => {
            navigate('/lead-uploader');
            setIsUploadOpen(true);
          }}
        >
          <img
            className="w-8 h-8 md:w-7 md:h-7 mx-1.5"
            src={isUploadOpen ? uploadIconActive : uploadIcon}
            alt="Upload Icon"
          />
          <span className="font-medium text-sm mt-2">Upload</span>
        </div>
      </div> */}

      {/* Profile Menu */}
      <div className="relative profile-menu-container mr-4">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
        >
          <div className="text-right mr-2">
            <div className="font-bold text-base lg:text-lg">Hi, {userName}</div>
            <div className="text-sm lg:text-base text-gray-600">{clientCompanyName}</div>
          </div>
          <div className="relative flex-shrink-0">
            <img
              className="w-10 h-10 lg:w-12 lg:h-12 rounded-full border-2 border-gray-200"
              src={logos.clientLogo}
              alt="Client Logo"
            />
            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border border-white"></div>
          </div>
        </div>

        {/* Dropdown */}
        {isProfileMenuOpen && (
          <div className="absolute right-0 mt-5 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
            <div className="px-4 py-2 border-b border-gray-100">
              <p className="text-sm font-medium text-gray-900">{userName}</p>
              <p className="text-xs text-gray-500">{userRole}</p>
            </div>
            <button
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={() => {
                handleNavigation('/lead-uploader/my-profile');
                setIsProfileMenuOpen(false);
              }}
            >
              Profile
            </button>
            <button
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={() => {
                handleSignout();
                setIsProfileMenuOpen(false);
              }}
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default AppBar;
